import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core'
import {NgbModal} from '@ng-bootstrap/ng-bootstrap'
import {ModalProgramDescBulletsComponent} from '../modal-program-desc-bullets/modal-program-desc-bullets.component'

@Component({
  selector: 'dmmp-search-programs-desc-bullets',
  templateUrl: './search-programs-desc-bullets.component.html'
})
export class SearchProgramsDescBulletsComponent implements OnInit {
  @Input() identifier
  @Input() data
  @Input() filterPrograms
  @Input() textNoFound = 'No se encontraron resultados'
  @Input() textAll = 'Todos'
  @Input() categories = []
  @Output() categoryOut = new EventEmitter()
  @Output() categoriesOut = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  status = true
  notEmptyPost = true
  statusInit = 8
  searchModel

  constructor(private modalService: NgbModal) {
  }

  ngOnInit() {
  }

  click(category) {
    this.categoryOut.emit(category)
  }

  sendData(data, identifier) {
    this.status = false
    const modalRef = this.modalService.open(ModalProgramDescBulletsComponent, {size: 'lg'})
    modalRef.componentInstance.data = data
    modalRef.componentInstance.identifier = identifier
    modalRef.componentInstance.categoriesOut.subscribe(($e) => {
      this.categoriesOut.emit($e)
    })
    modalRef.componentInstance.anchorCustom.subscribe(($e) => {
      this.anchorCustom.emit($e)
    })
  }

  onScroll() {
    if (this.notEmptyPost) {
      this.statusInit += 8
    }
  }
}
